import styled from 'styled-components';
import { darkwhite } from '@styles/colors';

export const Wrapper = styled.section`
  margin-top: 100px;
  margin-bottom: -300px;
  z-index: 200;
  position: relative;
`;

export const CardsWrapper = styled.div`
  margin-top: 80px;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
`;

export const CardIconWrapper = styled.div`
  border-radius: 100%;
  width: 100px;
  height: 100px;
  background: ${darkwhite};
  margin: 20px auto;

  & > svg {
    width: 50px;
    height: 50px;
    margin: 25px;
  }
`;



// WEBPACK FOOTER //
// src/app/src/components/SectionCards/SectionCards.s.ts